<template>
    <v-form @submit.prevent="addUpdate" ref="form">
        <v-card style="border-radius:4px;">
            <v-toolbar flat height="55px">
                <span class="font-weight-bold ">{{mode}} Payroll Adjustments</span>
                <v-spacer></v-spacer>
                <help-link appId="payroll" pageId="payroll-adustments-create" color="black"></help-link>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout row wrap> 
                    <v-flex xs12 sm6 class="form-row"> 
                        <v-autocomplete
                            v-model="userId"
                            :disabled="disabled||mode=='Update'"
                            :items="employees"
                            :loading="loading_employees"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Employee"
                            item-text="name"
                            item-value="userId"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="data.item.avatar"></v-img>
                                    </v-avatar>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                <v-list-tile-avatar>
                                    <img :src="data.item.avatar">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 :class="isMobile?'form-row':'form-row mt-10'"> 
                        <v-text-field label="Amount" 
                            v-model="amount" 
                            :disabled="disabled"
                            :rules="[rules.required]"
                            type="number" min="1" step="1" value="0.00" 
                            ></v-text-field>  
                   </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-row"> 
                         <v-select
                            label="Adjustment Type"
                            :items="adjustment_types"
                            :rules="[rules.required]" 
                            item-text="name"
                            item-value="manualAdjustmentTypesId"
                            :loading="loading_types"
                            :disabled="disabled"
                            v-model="manualAdjustmentTypesId"    
                            persistent-hint
                            :hint="manualAdjustmentTypesId ? adjustment_description : ''"
                        ></v-select> 
                    </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-15">
                    <v-flex xs12 sm6 class="form-row">  
                         <v-select
                            label="Journal Type"
                            :items="trans_types"
                            :rules="[rules.required]" 
                            item-text="description"
                            item-value="transType"
                            :disabled="disabled"
                            v-model="transType"  
                        ></v-select>  
                    </v-flex>
                    <v-flex xs12 sm6 v-if="transType==1"  class="form-row">
                        <v-switch
                            v-model="addToTaxableIncome"
                            label="Tax Treatment"
                            title="Determines whether the adjustment affects taxable income"
                            color="primary"
                            persistent-hint
                            :hint="addToTaxableIncome?'Taxable (added to taxable income)':'Non-taxable (not added to taxable income)'"
                            ></v-switch> 
                    </v-flex>       
                    <v-flex xs12 sm6 v-if="transType==2" class="form-row">
                        <v-switch
                            v-model="deductFromTaxableIncome"
                            label="Tax Treatment"
                            title="Determines whether the adjustment affects taxable income"
                            color="primary"
                            persistent-hint
                            :hint="deductFromTaxableIncome?'Deductible from taxable income':'Not deductible from taxable income'"
                            ></v-switch> 
                    </v-flex>           
                </v-layout>
                <v-layout row wrap v-if="showComment" class="mt-5"> 
                    <v-flex xs12 sm12 class="form-row"> 
                        <v-textarea v-model="remarks" label="Note" rows="1" color="primary"></v-textarea>
                    </v-flex>
                </v-layout>
                <v-layout row wrap v-if="showComment&&remarks" class="form-row-switch">  
                    <v-flex >
                        <v-switch                            
                            v-model="showNotesOnReports"
                            label="Show Notes on Payslip & Annualization"
                            color="primary"
                        ></v-switch> 
                    </v-flex>           
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon @click="showComment=!showComment" title="Add Note">
                    <v-icon>comment</v-icon>
                </v-btn>
                <v-btn v-if="mode!='Update'" @click="clearForm" :disabled="disabled" >Clear</v-btn>
                <v-btn color="primary" type="submit" :disabled="disabled" :loading="loading" class="mr-25">{{mode}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import manualAdjustmentsApi from '@/api/manualadjustments'
import employeeApi from '@/api/employees'
import awsS3Helper from '@/helpers/aws-s3'
import pageKeys from '@/common/pagekeys'

export default {
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    data () {
        return {
            loading: false,
            disabled: false,
            error: false,
            errorMessage: null,
            rules: {
                required: value => !!value || 'Required field'
            },
            trans_types: [
                {transType:1, description:"Credit (Add to Payroll)"},
                {transType:2, description:"Debit (Deduct from Payroll)"}
            ],
            mode: '',
            showComment: false,
            loading_types: false,
            loading_projects: false,
            loading_employees: false,
            adjustment_types: [],
            project_list: [],
            projecttask_list: [],
            menuProcessDate: false,
            manualAdjustmentId: null,
            transType: null,
            addToTaxableIncome: false,
            deductFromTaxableIncome: false,
            manualAdjustmentTypesId: 1,
            showNotesOnReports: false,
            userId: null,
            projectId: null,
            projectTaskId: null,
            amount: null,
            remarks: "",
            selectedCutoffId: null,
            employees: []
        }
    },
    methods: {
        async addUpdate() {
            try {
                this.loading = true
                this.disabled = true

                if (this.$refs.form.validate()) {
                    var data = {
                        manualAdjustmentId: this.manualAdjustmentId,
                        transType: this.transType,
                        manualAdjustmentTypesId: this.manualAdjustmentTypesId,
                        addToTaxableIncome: this.addToTaxableIncome,
                        deductFromTaxableIncome: this.deductFromTaxableIncome,
                        userId: this.userId,
                        projectTaskId: this.projectTaskId,
                        cutoffId: this.cutoffId,
                        amount: this.amount,
                        remarks: this.remarks,
                        showNotesOnReports: this.showNotesOnReports
                    }
                    var response = null
                    if (this.mode == 'Add')
                        response = await manualAdjustmentsApi.add(data)
                    else
                        response = await manualAdjustmentsApi.update(data)
                        
                    if (response.status == 200) {
                        this.$emit('send',response.data)
                        this.closeDialog()
                    }
                }
                this.loading = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        allowedDates(val) {
            return this.$moment(Date()).format('YYYY-MM-DD') <= this.$moment(val).format('YYYY-MM-DD')
        },
        async setAdd(cutoffId) {
            this.mode = 'Add'
            this.cutoffId = cutoffId
            
            this.userId = null
            this.manualAdjustmentId = null
            this.transType = null
            this.addToTaxableIncome = false
            this.deductFromTaxableIncome = false
            this.manualAdjustmentTypesId = null
            this.projectId = null
            this.projectTaskId = null
            this.amount = null
            this.remarks = ""
            this.showNotesOnReports = false

            //note getEmployees and getAdjustmentTypes can run parallel since there is no depenencies
            if (this.employees.length==0) this.getEmployees()
            if (this.adjustment_types.length==0) this.getAdjustmentTypes()
            
            this.clearForm()
        },
        async setUpdate(data) {
            this.mode = 'Update'

            this.manualAdjustmentId = data.manualAdjustmentId
            this.transType = data.transType
            this.addToTaxableIncome = data.addToTaxableIncome
            this.deductFromTaxableIncome = data.deductFromTaxableIncome
            this.manualAdjustmentTypesId = data.manualAdjustmentTypesId
            this.projectId = data.projectId
            this.projectTaskId = data.projectTaskId
            this.cutoffId = data.cutoffId
            this.amount = data.amount
            this.userId = data.userId
            this.remarks = data.remarks
            this.showNotesOnReports = data.showNotesOnReports
            this.showComment = data.showNotesOnReports || data.remarks

            //note getEmployees and getAdjustmentTypes can run parallel since there is no depenencies
            if (!this.employees.length) this.getEmployees()
            if (!this.adjustment_types.length) this.getAdjustmentTypes()

            this.projectTaskId = data.projectTaskId
        },        
        async getAdjustmentTypes() {
            try {
                this.disabled = true
                this.loading_types = true
                const response = await manualAdjustmentsApi.getTypes()
                if (response && response.status == 200) {
                    this.adjustment_types = response.data.items
                }
                this.loading_types = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getEmployees() {
            try {
                this.loading_employees = true
                this.employees = []
                const response = await employeeApi.getAllByPageKey(pageKeys.manual_adjustments)
                if (response && response.status == 200) {
                    const members = response.data.employees
                    members.forEach(item => {
                        this.employees.push({
                            userId: item.userId,
                            name: item.firstName + " " + item.lastName,
                            avatar: awsS3Helper.getAvatarUrl(item.userId),
                            group: item.team
                        })
                    })
                }
                this.loading_employees = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        closeDialog() {
            this.$emit('update:dialogManualAdjustments', false)
        },
        clearForm() {
            this.$refs.form.reset()
            this.remarks = ''
            this.loading = false
            this.error = false
            this.errorMessage = ''
        },
    },
    computed: {
        adjustment_description() {
            if (this.adjustment_types && this.adjustment_types.length) {
                return this.adjustment_types.find(x => x.manualAdjustmentTypesId == this.manualAdjustmentTypesId).description
            }
        },
    },
    created() {}
}
</script>
<style scoped>
.form-row {
    padding: 0px 25px 0px 25px; 
}
.form-row-switch{
    margin: -15px 25px 0px 25px; 
}
</style>